import React, { useState } from 'react';
//Material UI
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
//Components
import Modal from '../index';
//Hooks
import useNotify from '../../../hooks/notify';
// Service
import OrderService from '../../../services/orderService';
//Other
import { utils } from '../../../utils/utils';
import InputEmail from '../../inputs/input/email';


const ModalSendEmail = ({ country, open, maxWidthModal, title, styleButton, onCancel, onClose, voucherId, changeItems, email, isChange = false }) => {
    const { Notify, variants } = useNotify();
    const [data, setData] = useState({ voucherId, changeItems, email, isTaxFree: false, isChangeTicket: isChange });
    const [loading, setLoading] = useState(false);

    const handleValueChange = (value, name) =>
        setData({
            ...data,
            [name]: value
        });

    const handleSwitchChange = async (event) =>
        setData({
            ...data,
            [event.target.name]: event.target.checked
        });

    const sendEmail = async () => {
        setLoading(true);
        const services = isChange ? OrderService.SendEmailChangeTicket : OrderService.SendEmailTicket;

        services(data)
            .then(() => { Notify(`Se ha enviado el email con ${isChange ? "el ticket de cambio" : "la factura"} `, variants.SUCCESS); onClose() })
            .catch(() => Notify(`Error al intentar enviar el email con ${isChange ? "el ticket de cambio" : "la factura"} `, variants.ERROR))
            .finally(() => setLoading(false));
    }

    return (
        <Modal
            title={title}
            maxWidth={maxWidthModal || "sm"}
            disableEscapeKeyDown
            open={open}
            onClose={onClose}
        >
            <Grid container direction='column'>
                <Grid container>
                    {
                        loading &&
                        <Grid container justifyContent='center'>
                            <CircularProgress />
                        </Grid>
                    }
                    {
                        !loading &&
                        <Grid container style={{ display: "flex", justifyContent: "space-between", alignContent: "center", marginBottom: "1rem" }}>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12
                                }}
                            >
                                <InputEmail
                                    value={data?.email || ""}
                                    onChange={(value) => handleValueChange(value, "email")}
                                />
                            </Grid>
                            {country === "UY" && !isChange &&
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12
                                    }}
                                >
                                    <FormControlLabel
                                        label="Tax Free"
                                        control={
                                            <Switch
                                                color='primary'
                                                name='isTaxFree'
                                                onChange={handleSwitchChange}
                                                checked={data?.isTaxFree || false}
                                            />}
                                    />
                                </Grid>
                            }
                        </Grid>
                    }
                    <Grid container justifyContent='space-between'>
                        <Button
                            style={styleButton || { width: '40%' }}
                            onClick={onCancel}
                            color="primary"
                            variant='outlined'
                            autoFocus
                        >
                            Cancelar
                        </Button>
                        <Button
                            style={styleButton || { width: '40%' }}
                            onClick={sendEmail}
                            color="primary"
                            variant="contained"
                            disabled={utils.validateMail(data?.email)}
                        >
                            Enviar email
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Modal>
    );
}

export default ModalSendEmail;